module.exports = __webpack_public_path__ + "static/media/brand.b3daa0ae.svg";